import React, { useState, useCallback } from "react";

import { ReportIssueForm } from "../../../../forms/ReportIssueForm";

import { SuccessMessage } from "./SuccessMessage";

export function Route() {
  const [isDone, setIsDone] = useState(false);
  const setTrue = useCallback(() => { setIsDone(true); }, []);
  const setFalse = useCallback(() => { setIsDone(false); }, []);

  return isDone
    ? <SuccessMessage handleOnClick={setFalse} />
    : <ReportIssueForm successCallback={setTrue} />;
}
